import React, { useEffect, useState } from "react";
import { ourPartnersData } from "../common/Helper";
import { getPartner } from "../../services/PartnerServices";
import Slider from "react-slick";
import { getDronesParts } from "../../services/DroneServices";
import { Link } from "react-router-dom";

const Recruiters = () => {
  const [partners, setPartner] = useState([]);
  const [drones, setDrones] = useState([]);
  // const { id } = useParams();
  const [dronePage, setDronePage] = useState(1);
  const [droneTotalPage, setDroneTotalPage] = useState(1);
  const [droneCategory, setDroneCategory] = useState("All Drones");
  const [sort, setSort] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [model, setModel] = useState(false);
  const [droneDetails, setDroneDetails] = useState(null);
  const [specifications, setSpecifications] = useState([]);
  const [allDroneParts, setAllDroneParts] = useState([]);
  const [partsPage, setPartsPage] = useState(1);
  const [partsTotalPage, setPartsTotalPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    getPartner().then((res) => {
      setPartner(res.data);
    });
  }, []);
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 10000,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true, // Enable automatic scrolling
    autoplaySpeed: 0, // Set autoplay speed to 0 for continuous scroll
    cssEase: 'linear', // Use linear easing for continuous scrolling
    pauseOnHover: false, // Prevent pause on hover
    pauseOnFocus: false, // Prevent pause on focus
    pauseOnDotsHover: false, // Prevent pause on dots hover
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };
  useEffect(() => {
    fetchDroneParts();
  }, [partsPage]);

  const fetchDroneParts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getDronesParts({ limit: 8, page: partsPage, search: "" });
      if (response.status === "success") {
        setAllDroneParts((prevAllDroneParts) => [
          ...prevAllDroneParts,
          ...response.data.data,
        ]);
        if (response.data.totalPages !== 0) {
          setPartsTotalPage(response.data.totalPages);
        }
      } else {
        setError("Failed to fetch drone parts");
      }
    } catch (error) {
      setError("An error occurred while fetching drone parts");
    } finally {
      setLoading(false);
    }
  };

  const handleThumbnailClick = (thumbnail) => {
    setSelectedImage(thumbnail);
  };

  return (
    <div className="px-2" >
    <div className="py-5  overflow-hidden">
      <div className="container p-sm-1 py-1 bg_darkblue1 mt-1 rounded-3 pt-lg-0">
        <h3 className="fw-bold ff_inter text-center text-white fs_43 pt-2">
          Our Partners
        </h3>
        <div className="row our_partners">
          <Slider className="pb-4" {...settings}>
            {partners?.map((item, index) => {
              return (
                <div key={index} className="p-3 pt-0 mt-3">
                  <img
                    className="img-fluid rounded-2"
                    style={{ width: "200px", height: "100px" }} // Adjust the width and height as needed
                    src={item.image}
                    alt="Our Partners logo"
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
    {/* <div className="container py-0" style={{ backgroundColor: "#f1f9ff" }}>
      {allDroneParts.length !== 0 && (
        <h4 className="ff_inter fs_43 fw-semibold text-center">
          Get <span className="" style={{color: "#2596be"}}>Drone Parts</span>
        </h4>
      )}
      <div className="row pb-md-4">
        {allDroneParts.map((item, index) => (
          <div
            key={index}
            className="col-lg-3 col-md-4 col-sm-6 col-12 mt-4 cursor_pointer"
          >
            <Link to={`/drone-part-details/${item._id}`}>
              <div className="border d-flex flex-column justify-content-between border-1 h-100 rounded-3">
                <div>
                  <img
                    height={200}
                    className="mx-auto w-100 object-fit-cover w_xsm_full rounded-3 img-fluid"
                    src={item.images[0]}
                    alt="drone image"
                  />
                  <p className="px-3 mt-3 fs_15 fw-bold ff_inter color_darkgray mb-0 mt-3">
                    {item?.title.split("").slice(0, 50).join("")}...
                  </p>
                </div>
                <div className="mt-3 px-3">
                  <div className="mt-3 d-flex justify-content-between mb-3 align-items-center">
                    <div className="d-flex flex-column">
                      <span className="fs_15 fw-bold ff_inter color_darkgray mb-0">
                        Rs. {item.discountPrice}
                      </span>
                      <span className="text-decoration-line-through fs_15 ff_inter">
                        Rs. {item.price}
                      </span>
                    </div>
                    <div>
                      <button className="viewall_btn bg_light_blue px-4 py-2 fs_17 fw-medium ff_inter text-white text-nowrap">
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
        {loading && (
          <div className="d-flex justify-content-center">
            <p>Loading...</p>
          </div>
        )}
        {error && (
          <div className="d-flex justify-content-center">
            <p className="text-danger">{error}</p>
          </div>
        )}
        {partsPage !== partsTotalPage && (
          <div className="d-flex justify-content-center">
            <Link to="/drone-parts">
              <button
                onClick={() => setPartsPage(partsPage + 1)}
                className="tab_btn px-4 py-2 border-0 rounded-2 mt-5 fs_21 ff_inter fw-semibold text-white"
              >
                View More
              </button>
            </Link>
          </div>
        )}
      </div>
    </div> */}
  </div>
  
  );
};

export default Recruiters;